export const PickingListSearch = 'PICKINGLIST-SEARCH';
export const PickingListDaily = 'PICKINGLIST-DAILY';
export const PickingListSearchExcludeDispatched = 'PICKINGLIST-SEARCH-EXC-DISPATCHED';
export const PickingListSearchExcludePackaged = 'PICKINGLIST-SEARCH-EXC-PACKAGED';
export const PickingListSearchExcludePackagedAndDispatched = 'PICKINGLIST-SEARCH-EXC-PACKAGED-DISPATCHED';
